import React, {useState} from "react";
import {TextField} from "formik-material-ui";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import {Formik, Form, Field, FormikProps} from "formik";
import * as Yup from "yup";
import API from "../../../../helpers/apiHelpers";
import {useSnackbar} from "notistack";
import {signUpUser} from "../../../../redux/user/user.actions";
import {RootState, useAppDispatch} from "../../../../redux/store";
import {privacyPolicyURL, termsOfUseURL} from "../../../../Constants/api";
import {Checkbox, Typography, useMediaQuery} from "@material-ui/core";
import {ReactComponent as CheckboxBorder} from "../../../../Images/checkboxBorder.svg";
import {useSelector} from "react-redux";
import {useTheme} from "@material-ui/core/styles";
import {partners} from "../../../../Constants/partners";

interface Props {
    setIsOnBoarding: React.Dispatch<React.SetStateAction<boolean>>,
    setIsEmailConfirmed: (boolean) => void
}

interface IUserData {
    email: string,
    password: string,
    role: string,
    device: string,
    partnerEntity?: { id: number },
}

export default ({setIsOnBoarding, setIsEmailConfirmed}: Props) => {
    const validationSchema = Yup.object().shape({
        fullName: Yup.string()
            .required("Required"),
        emailAddress: Yup.string()
            .email("Invalid email")
            .required("Required"),
        password: Yup.string()
            .min(8, "Too Short!")
            .required("Required"),
        passwordConfirm: Yup.string()
            .oneOf([Yup.ref("password")], "Passwords must match")
            .required("Required"),
    });
    const {enqueueSnackbar} = useSnackbar();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const dispatch = useAppDispatch();
    const primaryColor = useSelector((state: RootState) => state?.branding.brandHeader);
    const partnerIdRedux = useSelector((state: RootState) => state?.branding.partnerId);
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const urlParams = new URLSearchParams(window.location.search);
    const partnerId = urlParams.get("partnerId");

    return (
        <Formik
            initialValues={{
                fullName: "",
                emailAddress: "",
                password: "",
                passwordConfirm: "",
            }}
            onSubmit={async (values, {setStatus}) => {
                try {
                    const subDomain = window.location.host.split(".")[0];
                    const partnerName = subDomain.replace(/qa/, "");
                    const userData: IUserData = {
                        email: values.emailAddress.toLowerCase(),
                        password: values.password,
                        role: "PARTNER",
                        device: isMobile ? "MOBILE" :"WEB"
                    };
                    if (partnerId) {
                        userData.partnerEntity = {id: +partnerId};
                    }
                    const user = await dispatch(signUpUser(userData));
                    if (!partnerId) {
                        localStorage.setItem("partner", JSON.stringify({
                            creatorId: user.id,
                            name: partnerName,
                            subscription: false,
                            url: `https://${subDomain}.thevideovets.com/`,
                        }));
                    }
                    API.isLoggedIn = true;
                    API.token = user.authenticationToken.token;
                    API.role = user.authenticationToken.role;
                    API.userId = user.authenticationToken.userId;
                    let expiry = new Date();
                    expiry.setTime(expiry.getTime() + 604800000);
                    document.cookie = "isOnBoarding=true;path=/;expires=" + expiry.toUTCString();
                    setIsOnBoarding(true);
                    setIsEmailConfirmed(false);
                    setStatus({success: true});
                } catch (error) {
                    enqueueSnackbar(error.errorMessage, {
                        variant: "error",
                        autoHideDuration: 3000
                    });
                    setStatus({success: false});
                }
            }}
            validationSchema={validationSchema}
        >
            {
                (props: FormikProps<{ fullName: string, emailAddress: string, password: string, passwordConfirm: string }>) => {
                    const checkEmailAvaliability = (email: string) => {
                        API.getUserEmailAvaliability(email).then((avaliability) => {
                        });
                    };
                    return (

                        <Form>
                            <Box
                                display="flex"
                                flexDirection="column"
                                flexWrap="wrap"
                                width="100%"
                                marginBottom="16px"
                            >
                                <Field
                                    component={TextField}
                                    name="fullName"
                                    id="fullName"
                                    aria-labelledby="Full Name"
                                    label="Full Name"
                                    variant="outlined"
                                    color="secondary"
                                    type="text"
                                    margin="normal"
                                    onChange={props.handleChange}
                                    value={props.values.fullName}
                                />
                                <Field
                                    component={TextField}
                                    name="emailAddress"
                                    label="Email Address"
                                    id="emailAddress"
                                    aria-labelledby="Email Address"
                                    variant="outlined"
                                    color="secondary"
                                    type="email"
                                    margin="normal"
                                    onChange={props.handleChange}
                                    onBlur={(e) => {
                                        props.handleBlur(e);
                                        checkEmailAvaliability(e.currentTarget.value);
                                    }}
                                    value={props.values.emailAddress}
                                />
                                <Field
                                    component={TextField}
                                    label="Password"
                                    id="password"
                                    aria-labelledby="Password"
                                    name="password"
                                    variant="outlined"
                                    color="secondary"
                                    type="password"
                                    margin="normal"
                                    onChange={props.handleChange}
                                    value={props.values.password}
                                />
                                {/* TODO: ПОСМОТРИ СЮДА!!!! https://stackworx.github.io/formik-material-ui/docs/guide/faq */}
                                <Field
                                    component={TextField}
                                    label="Confirm Password"
                                    id="passwordConfirm"
                                    aria-labelledby="Confirm Password"
                                    name="passwordConfirm"
                                    variant="outlined"
                                    color="secondary"
                                    type="password"
                                    margin="normal"
                                    onChange={props.handleChange}
                                    value={props.values.passwordConfirm}
                                />
                            </Box>
                            <Box display="flex" justifyContent="flex-start" alignItems="center" marginBottom="15px">
                                <Checkbox
                                    color="secondary"
                                    icon={<CheckboxBorder/>}
                                    style={{paddingLeft: 0}}
                                    value={checkboxChecked}
                                    onChange={() => {
                                        setCheckboxChecked(!checkboxChecked);
                                    }}
                                />
                                <Box>
                                    <Typography color="textPrimary" style={{fontSize: 14}}>
                                            I agree to the&nbsp;
                                        <a aria-label="read tearms of service" href={termsOfUseURL} target="_blank" rel="noreferrer"
                                            style={{color: primaryColor}}>Terms of Service & Privacy Policy</a>
                                    </Typography>
                                </Box>
                            </Box>
                            <Box onClick={() => {
                                if (!checkboxChecked) {
                                    enqueueSnackbar("Please agree to our Terms Of Service and Privacy Policy first.",
                                        {
                                            variant: "error",
                                            autoHideDuration: 4000
                                        });
                                }
                            }}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    type="submit"
                                    data-testid="submitButton"
                                    fullWidth
                                    disabled={!checkboxChecked}
                                >
                                        Continue
                                </Button>
                            </Box>
                        </Form>
                    );
                }
            }
        </Formik>
    );
};
